import React, {forwardRef, useEffect, useRef, Ref, useImperativeHandle} from 'react';

import createjs from 'createjs-module'
import {useState} from 'react';

export interface ICanvasRef {
    addChild: (container: createjs.Container) => void,
    reInitCanvas: () => void
}

export interface ICanvasProps {
    id: string;
    width: number;
    height: number;
}

const Canvas = forwardRef(({id, width, height}: ICanvasProps, ref: Ref<ICanvasRef>) => {

    useImperativeHandle(ref, () => ({addChild, reInitCanvas}));

    const canvasRef = useRef<HTMLCanvasElement | null>(null)

    const [children, setChildren] = useState<createjs.Container[]>([])

    const reInitCanvas = () => {
        setChildren([])
    }

    const addChild = (container: createjs.Container) => {

        if (canvasRef.current == null) {
            return;
        }

        setChildren((value: createjs.Container[]) => {
            return [...value, container]
        });
    }


    useEffect(() => {
        if (canvasRef.current == null) {
            return;
        }

        var stage = new createjs.Stage(id);
        stage.removeAllEventListeners();
        stage.removeAllChildren();

        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            stage.addChild(child);
        }
        stage.update();

    }, [children])


    /*
    const onCanvasClick = (e: MouseEvent) => {
        addRect({
            x: Math.random() * width,
            y: Math.random() * height,
            width: 50,
            height: 50
        })
    }
    

    const initCanvas = () => {
        if(canvasRef.current == null){
            return;
        }
        //canvasRef.current.style.backgroundColor = "#ff000099";
    }

    useEffect(() => {
        if (!canvasRef.current) {
            return;
        }

        initCanvas()

        const canvas: HTMLCanvasElement = canvasRef.current;
        canvas.addEventListener('click', onCanvasClick);
        return () => {
           canvas.removeEventListener('click', onCanvasClick);
        };
    }, [])*/

    return (
        <div className="canvas_container">
            <canvas ref={canvasRef} id={id} height={height} width={width}/>
        </div>
    );
});

Canvas.defaultProps = {
    width: window.innerWidth,
    height: window.innerHeight,
};

export default Canvas;